import React from "react";
import JobEntryDashboard from "components/app/crm/dashboard/job-entries/JobEntryDashboard";

const JobEntryDashboardPage = () => <JobEntryDashboard />;

export default JobEntryDashboardPage;
